import { Navigate, useLocation } from 'react-router-dom';
import { usePartnerAuth } from '@/contexts/PartnerAuthContext';

interface PartnerProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Route guard for partner portal routes
 * Redirects to partner login if not authenticated
 */
export function PartnerProtectedRoute({ children }: PartnerProtectedRouteProps) {
  const { isAuthenticated, isLoading } = usePartnerAuth();
  const location = useLocation();

  // Show loading state while checking auth
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-4">
          <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    // Preserve the current path to redirect back after login
    return (
      <Navigate
        to="/partner/login"
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  return <>{children}</>;
}
